export const TRANSLATIONS_ZH = {};